// extracted by mini-css-extract-plugin
export default {"buttons":"Buttons_buttons__ozrQ+","inlineLinkTheme":"Buttons_inlineLinkTheme__MSxPc"};